import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom';
import { getPayloadFromURLParams } from '../../helper/URLParamsHelper';
import { getFileNameFromExt, getFileTypeFromUrl, modifyDataForDocumentViewerUrlInsertion } from '../../helper/helperTableFunctions';
import GenericSpinnerLoader from '../../loaders/GenericSpinnerLoader';
import { dispatchHandler, handleApiChange } from '../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import Icons from '../../assets/icons';
import GenericCustomButton from '../GenericCustomButton';
import { ChevronLeft, ChevronRight, FileText, IndianRupeeIcon, Power, X } from 'lucide-react';
import GenericInput from '../input/GenericInputComponent';
import GridListToggle from './documentViewerComponents/GridListToggle';
import GenericTabsComponent from '../GenericTabsComponent';
import ExpandedRow from '../oldGenericComponents/tableHelperComponents/ExpandedRow';
import CommentBoxModalWrapper from '../oldGenericComponents/tableHelperComponents/comments/CommentBoxModalWrapper';
import DocumentViewerDetailsModal from './documentViewerComponents/DocumentViewerDetailsModal';
import moment from 'moment';
import ParentModal from '../ParentModal';
import DocumentViewDetails from './DocumentViewDetails';
import CopyContentGenericComponent from '../CopyContentGenericComponent';
import GenericMediaViewModal from '../media/GenericMediaViewModal';
import LanguageTranslator from '../../locals/LanguageTranslator';
import DocumentsDropdown from '../oldGenericComponents/tableHelperComponents/DocumentsDropdown';
import { getPermissionKey } from '../../helper/permissions';
import DownloadReport from '../oldGenericComponents/tableHelperComponents/DownloadReport';
import { parseJwt } from '../../helper/genericFunction';
import DesignStagesModal from '../../components/dashboard/tna/DesignStagesModal';

const DocumentViewer = (props) => {

    const jumpInputRef = useRef();

    let { closeModal, documentViewerConfig = {}, renderRightClickOptions, tableConfig, renderBraedCrumps, embedded = false, documentInfoOverride = null } = props || {};

    let {
        headerConfig = {},
        headerKeys = {},
        columnConfig = {},
        search = {},
        modifyExpandFirstListData = null,
        modifyExpandSecondListData = null,
        removeGridListToggle = false,
        headerKeyIcons = {},
        docTabData = {},
        isMultipleLevelAvailable = () => false,
        docViewerHeaderKeys = {},
        imageKey = "",
        modifyMainLevelData = null,
        docViewerComment = {},
        actionBarConfig = {},
        addKeysWithCurrentKeysData = {}
    } = documentViewerConfig || {};

    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);

    const uType = parseJwt(sessionStorage.getItem('token')).uType?.toUpperCase() || "ENT";

    const getDocumentViewerData = useSelector(state => state?.generalStore?.getDocumentViewerData);
    const getDocumentViewerSecondLevelData = useSelector(state => state?.generalStore?.getDocumentViewerSecondLevelData);
    const getDocumentViewerThirdLevelData = useSelector(state => state?.generalStore?.getDocumentViewerThirdLevelData);
    const generalStore = useSelector(state => state?.generalStore);

    // States : For Document Viewer will be shown here
    const [documentInfo, setDocumentInfo] = useState(null);

    const [loading, setLoading] = useState({})

    const [errorData, setErrorData] = useState({});

    const [documentData, setDocumentData] = useState({
        headerLevel: {},
    })
    const [openDropdown, setOpenDropdown] = useState(false)

    // state : to check for search value
    const [currentSearch, setCurrentSearch] = useState("");
    // State : To store the filters data
    const [filtersData, setFiltersData] = useState({});

    // State : To store the current mode grid or list
    const [mode, setMode] = useState("list");

    // State: To store the current tab
    const [currentTab, setCurrentTab] = useState(Object.keys(docTabData || {})?.[0] || "");

    // State : To store the expanded row data
    const [expandedRow, setExpandedRow] = useState({});

    const [detailsModal, setDetailsModal] = useState({});
    const [selectedModal, setSelectedModal] = useState(false)

    const [tabsData, setTabsData] = useState(docTabData || {})

    const [getDocumentViewHeadersData, setGetDocumentViewHeadersData] = useState({})

    const [documentsDropdown, setDocumentsDropdown] = useState(false);

    const [downloadDocumentsConfigurationObject, setDownloadDocumentsConfigurationObject] = useState({})

    const [secondExpandData, setSecondExpandData] = useState({
        currentPage: 1,
        maxPage: 1,
        pageSize: 10,
        pageNumber: 1,
    });
    const [enableJumpPage, setEnableJumpPage] = useState(false);

    const [downloadReportModal, setDownloadReportModal] = useState(false);

    const [callHeaderApiAtFirstTime, setCallHeaderApiAtFirstTime] = useState(false)
    const [detailsHeaders, setDetailsHeaders] = useState({})

    // Queue of header keys still to be fetched. The main header and every detail
    // header share the `getHeadersData` redux slice, which uses takeLatest — so
    // firing them all at once makes every request except the last get cancelled,
    // leaving tabs with empty column headers (blank table). We fetch them one at
    // a time, dispatching the next only after the previous response has landed.
    const detailHeadersQueueRef = useRef([]);
    // Whether a header request from the queue is currently in flight. Guards
    // against two chains racing on the shared slice.
    const detailHeadersInFlightRef = useRef(false);

    // Function : Add header keys to the queue and start draining it if idle.
    const enqueueHeaderFetch = (keys) => {
        const list = Array.isArray(keys) ? keys : [keys];
        detailHeadersQueueRef.current.push(...list.filter(Boolean));
        if (!detailHeadersInFlightRef.current) fetchNextDetailHeader();
    }

    // Function : Dispatch the next queued header request (if any). MAIN maps to
    // the `doc-view-main` basedOn, every other key to `docView-<key>`.
    const fetchNextDetailHeader = () => {
        const nextKey = detailHeadersQueueRef.current.shift();
        if (!nextKey) {
            detailHeadersInFlightRef.current = false;
            return;
        }
        detailHeadersInFlightRef.current = true;
        handleApiChange(dispatch, "getHeadersRequest", {
            enterpriseName: "TURNINGCLOUD",
            displayName: docViewerHeaderKeys?.[nextKey]?.key,
            basedOn: nextKey === "MAIN" ? `doc-view-main` : `docView-${nextKey}`
        }, documentViewerConfig?.permissionsObj?.view)
    }

    const resetData = () => {
        setDetailsModal({});
        setSelectedModal(false)
        setExpandedRow({});
        setCurrentTab("");
        setOpenDropdown(false);
        setDocumentData({
            headerLevel: {},
        })
        setLoading({ getDocumentInfo: true });
    }

    // Simulate ESC key press programmatically (for your custom logic)
    const triggerEscape = () => {
        const escEvent = new KeyboardEvent("keydown", {
            key: "Escape",
            keyCode: 27,
            code: "Escape",
            which: 27,
            bubbles: true,
        });
        document.dispatchEvent(escEvent);
    };

    useEffect(() => {
        triggerEscape();
        document.addEventListener("keydown", handleKeywordPress);
        return () => {
            document.removeEventListener("keydown", handleKeywordPress);
        };
    }, [])

    // Function: to handle the keyboard shortcuts
    const handleKeywordPress = (e) => {
        if (e.key == "Escape") {
            closeDocumentViewer();
        }
    };

    useEffect(() => {
        if (props.refreshData) {
            resetData();
            getData()
        }
    }, [props.refreshData])

    useEffect(() => {
        if (getDocumentViewerData?.isError) {
            setErrorData({
                "getDocumentInfo": `Failed to get the document info.`,
            })
            let updatedLoading = { ...loading };
            delete updatedLoading?.["getDocumentInfo"];
            setLoading(updatedLoading);
        }
        if (getDocumentViewerData?.isSuccess) {
            let updatedLoading = { ...loading };
            delete updatedLoading?.["getDocumentInfo"];
            updatedLoading["getDocumentViewerSecondLevel"] = true;
            setLoading(updatedLoading);
            let data = getDocumentViewerData?.data;
            let listData = modifyMainLevelData ? modifyMainLevelData?.(data) : data?.resource || {};
            Object.keys(addKeysWithCurrentKeysData || {})?.map((key) => {
                listData[key] = listData?.[addKeysWithCurrentKeysData?.[key]]
            });
            updateDocumentInfo("headerLevel", listData);
            setTimeout(() => {
                getDocumentViewerDetails("expand1", listData);
            }, 0)
        }
    }, [getDocumentViewerData]);

    // Changes :To handle the response of the first expand api
    useEffect(() => {
        if (getDocumentViewerSecondLevelData?.isError) {
            setErrorData({
                "getDocumentViewerSecondLevel": `Failed to get the document info.`,
            })
            let updatedLoading = { ...loading };
            delete updatedLoading?.["getDocumentViewerSecondLevel"];
            setLoading(updatedLoading);
        }
        if (getDocumentViewerSecondLevelData?.isSuccess) {
            let updatedLoading = { ...loading };
            delete updatedLoading?.["getDocumentViewerSecondLevel"];
            let data = getDocumentViewerSecondLevelData?.data;
            let listData = modifyExpandFirstListData ? modifyExpandFirstListData?.(data, {
                mainExpandedRow: documentData?.headerLevel,
            }) : props?.getExpandFirstListData ? props.getExpandFirstListData(data, {
                mainExpandedRow: documentData?.headerLevel,
            }) : data?.resource || [];
            if (currentTab === "ITEM" || currentTab == "BOX") {
                setSecondExpandData((prevState) => ({
                    ...prevState,
                    currentPage: data?.currPage,
                    maxPage: data?.maxPage,
                    totalRecord: data?.totalRecord
                }));
            }
            setLoading(updatedLoading);
            updateDocumentInfo("secondLevel", listData);
        }
    }, [getDocumentViewerSecondLevelData])

    // Changes : To handle the response of the second expand api
    useEffect(() => {
        if (getDocumentViewerThirdLevelData?.isSuccess) {
            let data = getDocumentViewerThirdLevelData?.data
            let uniqueId = getDocumentViewerThirdLevelData.data?.uniqueExpandId;
            if (uniqueId && loading?.["expandLoading"]?.[uniqueId]) {
                let listData = modifyExpandSecondListData ? modifyExpandSecondListData(data) : props?.getExpandSecondListData ? props.getExpandSecondListData(data) : data?.resource || [];
                updateDocumentInfo("thirdLevel", listData, uniqueId);
                let updatedLoading = { ...loading };
                delete updatedLoading?.["expandLoading"]?.[uniqueId];
                setLoading(updatedLoading);
            }
        }
        if (getDocumentViewerThirdLevelData?.isError) {
            let uniqueId = getDocumentViewerThirdLevelData.data?.uniqueExpandId;
            if (uniqueId && loading?.["expandLoading"]?.[uniqueId]) {
                let updatedLoading = { ...loading };
                delete updatedLoading?.["expandLoading"]?.[uniqueId];
                setLoading(updatedLoading);
            }
        }
    }, [getDocumentViewerThirdLevelData])

    useEffect(() => {
        if (documentInfoOverride) {
            setDocumentInfo(documentInfoOverride);
        } else {
            updateDocumentViewerInfo();
        }
    }, [location, documentInfoOverride])

    // Function : On document info changes call for the api
    useEffect(() => {
        getData();
        // The main header and all detail headers share the getHeadersData redux
        // slice (takeLatest). Queue the main header alongside the detail ones so
        // they are fetched one-by-one instead of cancelling each other. The
        // detail keys are appended when the second-level data starts loading.
        if (docViewerHeaderKeys?.["MAIN"]?.key) {
            enqueueHeaderFetch("MAIN");
        }
    }, [documentInfo]);

    // Lets a caller open the viewer directly on a specific tab (e.g. Task Manager
    // opening straight to "Comments") by passing an `openTab` key through the
    // documentViewerConfig URL param decoded into documentInfo.
    useEffect(() => {
        if (documentInfo?.openTab && Object.keys(tabsData || {})?.includes(documentInfo.openTab)) {
            setCurrentTab(documentInfo.openTab);
        }
    }, [documentInfo]);

    useEffect(() => {
        let basedOn = generalStore?.getHeadersData?.data?.basedOn;
        let isDocViewerHeader = basedOn === "doc-view-main" || basedOn?.includes("docView");

        if (generalStore.getHeadersData?.isSuccess) {
            if (basedOn === "doc-view-main") {
                let getType = Object.keys(generalStore?.getHeadersData?.data?.resource?.["Custom Headers"] || {})?.length > 0 ? "Custom Headers" : "Default Headers";
                setGetDocumentViewHeadersData({
                    headersType: getType,
                    headersData: generalStore?.getHeadersData?.data?.resource
                })
            }
            else if (basedOn?.includes("docView")) {
                let changeBasedOn = basedOn?.replace("docView-", "") || "";
                setDetailsHeaders(updatedHeadersData => {
                    let headersType2 = Object.keys(generalStore?.getHeadersData?.data?.resource?.["Custom Headers"] || {})?.length > 0 ? "Custom Headers" : "Default Headers";
                    return {
                        ...updatedHeadersData,
                        [changeBasedOn]: {
                            headersData: generalStore?.getHeadersData?.data?.resource,
                            headersType: headersType2
                        }
                    };
                })
            }
        }

        // A queued header request settled (success or error) — drain the next
        // one so takeLatest doesn't cancel requests still waiting in the queue.
        if ((generalStore.getHeadersData?.isSuccess || generalStore?.getHeadersData?.isError) && isDocViewerHeader) {
            fetchNextDetailHeader();
        }

        if (generalStore?.getDocumentDropdownData?.isSuccess) {
            let documentsDropdownData = generalStore?.getDocumentDropdownData?.data?.resource || {};
            setDownloadDocumentsConfigurationObject(documentsDropdownData || {})
        }

        if(!getPayloadFromURLParams({ l: location })?.displayName && generalStore.downloadReportData?.isSuccess && generalStore?.downloadReportData?.data?.resource) {
            window.open(generalStore.downloadReportData?.data?.resource);
        }

    }, [generalStore.getHeadersData?.isSuccess, generalStore.getHeadersData?.isError, generalStore?.getDocumentDropdownData?.isSuccess, generalStore.downloadReportData?.isSuccess]);

    const getData = () => {
        if (Object.keys(documentInfo || {})?.length > 0) {
            getDocumentMainLevelData();
        }
    }

    const applySearchAndFilterOnDocumentSecondLevel = (search = currentSearch, filters = filtersData) => {
        getDocumentViewerDetails("expand1", documentData?.["headerLevel"], {search: search});
    }

    const updateDocumentInfo = (type, data, expandedId) => {
        switch (type) {
            case "headerLevel": {
                setDocumentData({
                    headerLevel: data,
                })
                break;
            }
            case "secondLevel": {
                setDocumentData(prev => {
                    delete prev?.["expandData"]?.[data?.id];
                    return {
                        ...prev,
                        "secondLevel": data,
                    }
                });
                break;
            }
            case "thirdLevel": {
                if (expandedId) {
                    setDocumentData(prev => {
                        if (!prev?.["expandData"]) prev["expandData"] = {};
                        prev["expandData"][expandedId] = data;
                        return prev;
                    })
                }
                break;
            }
            default: {
                break;
            }
        }
    }

    // Function : To get the first level of document informatio n
    const getDocumentViewerDetails = (type, data, config = {}) => {
        let { search = currentSearch, filters = filtersData, pageNo = 1 } = config || {};
        switch (type) {
            case "expand1": {
                // let expand1Data = { ...(documentViewerConfig?.expand?.(data)) }
                // if (!expand1Data?.["render"] && props.getExpandFirstPayload) {
                setLoading(prev => {
                    delete prev?.["expandLoading"];
                    return { ...prev, getDocumentViewerSecondLevel: true }
                });
                setErrorData(prev => {
                    delete prev?.["getDocumentViewerSecondLevel"];
                    return prev;
                })
                setDocumentData(prev => {
                    delete prev?.["expandData"];
                    return prev;
                })
                setExpandedRow({});
                if (!callHeaderApiAtFirstTime) {
                    setCallHeaderApiAtFirstTime(true);
                    // Queue every detail-header key (except MAIN). They are fired
                    // sequentially as each response arrives (see the getHeadersData
                    // success effect) so takeLatest doesn't cancel them.
                    enqueueHeaderFetch(Object.keys(docViewerHeaderKeys || {}).filter(key => key != "MAIN"));
                }
                // Call for the document info change
                if (documentViewerConfig?.getPayload?.({ type: isMultipleLevelAvailable?.(data || {}) ? "setLevel" : currentTab, documentInfo })) {
                    dispatchHandler(dispatch, "getDocumentViewerSecondLevelRequest", { ...documentViewerConfig?.getPayload?.({ type: (isMultipleLevelAvailable?.(data || {}) && currentTab == "ITEM") ? "setLevel" : currentTab, documentInfo, data: data }), search: search || "", pageNo: (currentTab == "ITEM" || currentTab == "BOX") ? pageNo : undefined, }, documentViewerConfig?.["permissionsObj"]?.["view"])
                }
                else dispatchHandler(dispatch, "getDocumentViewerSecondLevelRequest", { ...props?.getExpandFirstPayload?.({ ...data, poType: data?.po_type, }), search: search || "", pageNo: (currentTab == "ITEM" || currentTab == "BOX") ? pageNo : undefined }, documentViewerConfig?.["permissionsObj"]?.["view"])
                // }
                break;
            }
            case "expand2": {
                if (expandedRow?.[data?.id]) {
                    let updatedExpandedRow = { ...expandedRow };
                    delete updatedExpandedRow?.[data?.id];
                    setExpandedRow(updatedExpandedRow)
                    setDocumentData(prev => {
                        delete prev?.["expandData"]?.[data?.id];
                        return prev;
                    })
                } else {
                    let updatedLoading = { ...loading };
                    if (!updatedLoading?.["expandLoading"]) {
                        updatedLoading["expandLoading"] = {};
                    }
                    updatedLoading["expandLoading"][data.id] = true;
                    setLoading(updatedLoading);
                    setExpandedRow(prev => {
                        prev[data.id] = data;
                        return prev;
                    })

                    if (documentViewerConfig?.getPayload?.({ type: "itemLevel", documentInfo })) {
                        dispatchHandler(dispatch, "getDocumentViewerThirdLevelRequest", { ...documentViewerConfig?.getPayload?.({ type: "itemLevel", documentInfo, data: data }), uniqueExpandId: data.id, search: search || "", filter: filters || {} }, documentViewerConfig?.["permissionsObj"]?.["view"])
                    }
                    else dispatchHandler(dispatch, "getDocumentViewerThirdLevelRequest", { ...props?.getExpandSecondPayload?.(data, { ...documentData?.["headerLevel"], "poType": documentData?.["headerLevel"]?.po_type }), uniqueExpandId: data.id }, documentViewerConfig?.["permissionsObj"]?.["view"])
                }
                break;
            }
            default: {
                break;
            }
        }
    }


    const getDocumentMainLevelData = () => {
        setLoading(prev => ({ ...prev, getDocumentInfo: true }));
        setErrorData(prev => {
            delete prev?.["getDocumentInfo"];
            return prev;
        })
        // Call for the document info change
        dispatchHandler(dispatch, "getDocumentViewerRequest", documentViewerConfig?.getPayload({
            type: "header", documentInfo,
        }), documentViewerConfig?.["permissionsObj"]?.["view"])
        handleApiChange(dispatch, "getDocumentDropdownRequest", actionBarConfig?.quickFiltersPayload, documentViewerConfig?.["permissionsObj"]?.["view"]);
    }

    // Function : To get the document info from the location
    const updateDocumentViewerInfo = () => {
        let params = getPayloadFromURLParams({ l: location });

        let obj = {};
        if (params?.documentViewerConfig) {
            obj = modifyDataForDocumentViewerUrlInsertion("decode", params?.documentViewerConfig);
            if (["documentId", "documentNo", "documentType"]?.every(key => params?.documentViewerConfig?.[key])) {
                setDocumentInfo(obj);
            }
        } else {
            setDocumentInfo({});
        }
    }

    const closeDocumentViewer = () => {
        document.getElementById("documentViewerModal")?.classList?.remove("from-bot-in")
        document.getElementById("documentViewerModal")?.classList?.add("from-bot-out")
        setTimeout(() => {
            closeModal?.();
        }, 100)
    }

    // Function : To render the status keys
    const renderStatusKeys = (key) => {
        switch (key) {
            case "is_set": {
                return <div className='-mt-0.5'>
                    {columnConfig?.[key]?.({ data: documentData?.headerLevel })}
                </div>
            }
            case "status": {
                return <div>
                    {columnConfig?.[key]?.(documentData?.headerLevel)}
                </div>
            }
            case "view_remarks": {
                // If remarks data is present then only render the status keys data
                return documentData?.headerLevel?.[headerConfig?.["section1"]?.["remarksKey"]] && <div className='text-[#2969FF] bg-[#2969FF33] px-2 py-1 rounded-[3px] flex items-center gap-1'>
                    <p className='mb-0 text-[11px] font-semibold'>View Remarks</p>
                    <ChevronRight size={15} color='#2969FF' />
                </div>
            }
            default: return null;
        }
    }

    // Function : To check for the handle change
    const handleChange = (type, data) => {
        switch (type) {
            case "viewDetailsModal": {
                // setDetailsModal(data);
                // handleToggleAllDetsPopover(data?.e)

                data?.e.stopPropagation();
                setDetailsModal(data);
                // setSelectedData((prev) => Object?.keys(prev || {})?.length > 0 ? {} : data)
                setSelectedModal("allDetailsModal");
                break;
            }
            case "openMediaViewModal": {
                setDetailsModal(data?.[imageKey] || "");
                setSelectedModal("viewImagePreview");
                break;
            }
            case "goBack": {
                history.goBack();
                setTimeout(() => {
                    history.goBack();
                }, 300);
                break;
            }
            case "designStage": {
                setSelectedModal(type);
                setDetailsModal(data);
                break;
            }
            default: {
                break;
            }
        }
    }

    const closeDropdown = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpenDropdown(false);
            document.removeEventListener('click', closeDropdown)
        }
    }

    const handleToggleDropdown = (event) => {
        event.stopPropagation();
        setOpenDropdown((prev) => !prev);
        setTimeout(() => document.addEventListener('click', closeDropdown), 0)
    };

    const getItemsList = () => {
        return { [documentInfo?.documentId]: documentData?.headerLevel };
    }

    const getUnreadCommentForThisDocument = () => {
        return ""
    }

    const applyFilter = (checkedFilters) => () => {
        setFiltersData(checkedFilters);
        getDocumentViewerDetails("expand1", documentData?.headerLevel, { search: currentSearch, filters: checkedFilters });
    }

    useEffect(() => {
        if (Object.keys(documentData?.headerLevel || {})?.length && (currentTab !== "liveComments")) {
            updateDocumentInfo("secondLevel", []);
            getDocumentViewerDetails("expand1", documentData?.headerLevel, { search: currentSearch, filters: {} });
        }
    }, [currentTab])

    useEffect(() => {
        if (Object.keys(documentData?.headerLevel || {})?.length) {
            let tabsDataUpdate = { ...tabsData };
            if ((documentData?.headerLevel?.po_type && documentData?.headerLevel?.po_type != "raisedIndent") || uType === "VENDOR") {
                delete tabsDataUpdate?.["PI"];
            }
            if ("box_count" in documentData?.headerLevel && (documentData?.headerLevel?.box_count == 0 || !documentData?.headerLevel?.box_count)) {
                delete tabsDataUpdate?.["BOX"];
            }
            if (documentData?.headerLevel?.qc_status && documentData?.headerLevel?.qc_status == "NOT_REQUIRED") {
                delete tabsDataUpdate?.["INSPECTION"];
            }
            setTabsData(tabsDataUpdate);
        }
    }, [documentData?.headerLevel])

    console.log("headers data details", detailsHeaders);

    // Function : To render the document details
    const renderDocumentDetails = () => {
        switch (currentTab) {
            case "ITEM": case "ASN": case "LR": case "GRC": case "PI": case "PO": case "INSPECTION": case "BOX": case "DISCREPANCIES": {

                let expand1Data = { ...(documentViewerConfig?.expand?.(documentData?.["headerLevel"])) }
                let mainItem = documentData?.["headerLevel"];

                let Document = <div className={`imt-manage-table h-full ${mode === 'grid' ? 'p-[16px] pt-[0px]' : ''}`}>
                    {documentViewerConfig.expand &&
                        mode === 'grid' ?
                        <div className='h-full'>
                            {(expand1Data?.render) ? (expand1Data?.render?.({
                                documentData: documentData,
                                documentInfo,
                            })) :
                                <>
                                    <DocumentViewDetails
                                        currentTab={currentTab}
                                        expandedData={documentData?.["secondLevel"] || []}
                                        mainLevelData={mainItem}
                                        documentViewerConfig={documentViewerConfig}
                                        isMultipleLevelAvailable={isMultipleLevelAvailable}
                                        loading={loading?.["getDocumentViewerSecondLevel"] || getDocumentViewerSecondLevelData?.isLoading}
                                        onRefresh={() => getDocumentViewerDetails("expand1")}
                                        handleChange={handleChange}
                                        detailsHeaders={detailsHeaders}
                                        documentInfo={documentInfo}
                                        location={location}
                                    />
                                </>}
                        </div>
                        :
                        <tr className='block h-full'>
                            <td colSpan="100%" className="pad-0 block h-full">
                                {(expand1Data?.render) ? (expand1Data?.render?.({
                                    documentData: documentData,
                                    documentInfo
                                })) :
                                    <>
                                        <DocumentViewDetails
                                            currentTab={currentTab}
                                            expandedData={documentData?.["secondLevel"] || []}
                                            mainLevelData={mainItem}
                                            documentViewerConfig={documentViewerConfig}
                                            isMultipleLevelAvailable={isMultipleLevelAvailable}
                                            loading={loading?.["getDocumentViewerSecondLevel"] || getDocumentViewerSecondLevelData?.isLoading}
                                            onRefresh={() => getDocumentViewerDetails("expand1")}
                                            handleChange={handleChange}
                                            detailsHeaders={detailsHeaders}
                                            documentInfo={documentInfo}
                                            location={location}
                                        />
                                    </>}
                            </td>
                        </tr>
                    }
                </div>

                switch (mode) {
                    case "grid": {
                        return (
                            <div className='h-full'>
                                {Document}
                            </div>
                        )
                    }
                    case "list": {
                        return (
                            <div className='documentViewerTable invoice-manage-table pad-top-10 mainbgColor !pt-[0] h-full overflow-auto'>
                                {Document}
                            </div>
                        )
                    }
                    default: return null;
                }
            }
            case "liveComments": {
                return <div className='flex-1 h-full overflow-auto'>
                    <CommentBoxModalWrapper
                        item={documentData?.headerLevel}
                        comment={docViewerComment}
                        isDocumentViewer={true}
                    />
                </div>
            }
            case "history": {
                return <div>

                </div>
            }
            default: return null;
        }
    }

    const getHeadersData = (level, mainItem) => {
        switch (level) {
            case 0: {
                return {
                    headersData: getDocumentViewHeadersData?.headersData ?? props.headersData?.["main"],
                    headersType: getDocumentViewHeadersData?.headersType ?? props?.headersType?.["main"],
                }
            }
            case 1: {
                let headersData = (props?.expandSecondKey ? isMultipleLevelAvailable?.(mainItem || {}) : true) ? props?.headersData?.[typeof (props?.expandFirstKey) == "function" ? props?.expandFirstKey?.(mainItem || {}) : props.expandFirstKey] : props.headersData?.[typeof (props?.expandSecondKey) == "function" ? props.expandSecondKey(mainItem || {}, mainItem || {}) : props.expandSecondKey]
                let headersType = (props?.expandSecondKey ? isMultipleLevelAvailable?.(mainItem || {}) : true) ? props?.headersType?.[typeof (props?.expandFirstKey) == "function" ? props?.expandFirstKey?.(mainItem || {}) : props.expandFirstKey] : props.headersType?.[typeof (props?.expandSecondKey) == "function" ? props.expandSecondKey(mainItem || {}, mainItem || {}) : props.expandSecondKey]
                return {
                    headersData, headersType
                }
            }
        }
    }

    const changePage = (page) => {
        setSecondExpandData((prevState) => ({
            ...prevState,
            currentPage: page,
        }));
        getDocumentViewerDetails("expand1", documentData?.headerLevel, { search: currentSearch, pageNo: page, });
    }

    const setPageNumberValue = (e) => {
        let pageNumber = Number(e.target.value),
            valid = e.target.value == "" || (/^\d*$/.test(pageNumber) && pageNumber > 0 && pageNumber <= secondExpandData?.maxPage);
        if (valid) {
            setSecondExpandData((prevState) => ({
                ...prevState,
                pageNumber: pageNumber,
            }));
            if (e.key == "Enter" && pageNumber && pageNumber != secondExpandData?.currentPage) {
                changePage(pageNumber);
                setEnableJumpPage(false);
                setTimeout(() => document.removeEventListener("click", closeJumpPage), 0)
            }
        }
    }

    const closeJumpPage = (e) => {
        if (jumpInputRef?.current && !jumpInputRef.current.contains(e.target)) {
            setEnableJumpPage(false);
            setTimeout(() => document.removeEventListener("click", closeJumpPage), 0)
        }
    }

    const handleJumpPage = () => {
        setEnableJumpPage(true);
        setTimeout(() => document.addEventListener("click", closeJumpPage), 0)
    }

    // Function : To render the document
    const renderDocument = () => {

        if (loading?.["getDocumentInfo"] || getDocumentViewerData?.isLoading) {
            return <div className='h-full flex items-center justify-center'>
                <GenericSpinnerLoader />
            </div>
        }

        if (errorData?.["getDocumentInfo"]) {
            return <div className='h-full flex flex-col gap-4 items-center justify-center' onClick={() => { getDocumentMainLevelData() }}>
                <Icons.ReloadIcon />
                <p>{errorData?.["getDocumentInfo"] || "Something Went Wrong!"}</p>
            </div>
        }

        const getFileIcon = {
            'po_quantity': <Icons.PoQty />,
            'grc_qty': <Icons.GrcQty />,
            'asn_qty': <Icons.AsnQty />,
            'canceled_qty': <Icons.CancelledQty />,
            'pending_qty': <Icons.PendingQty />,
            'po_amount': <Icons.PoAmountIgstGst />,
            'invoice_amount': <Icons.InvoiceAmount />,
            'order_canceled_qty': <Icons.CancelledQty />,
            'pending_qty': <Icons.PendingQty />
        }

        // Helper function to format relative time
        const formatTime = (timestamp) => {
            const now = moment();
            const createdTime = moment(timestamp);
            return timestamp ? `(${createdTime?.from(now)})` : "";
        };

        const CURRENCIES = { INR: "₹", USD: "$", EUR: "€", GBP: "£", YUAN: "¥" };

        const handleDocumentsDropdown = () => {
            setDocumentsDropdown(!documentsDropdown)
        }

        return <div className='flex flex-col h-full'>
            <div className='p-[14px] bg-[#F6FAFF]'>
                <div className='pb-3 bg-white rounded-[5px]' style={{ boxShadow: '0px 0px 4px 0px #0000000F' }}>
                    <div className='px-4 py-4 flex items-start justify-between gap-5'>
                        <div>

                            {/* Document Main Information Starts */}
                            <div className='flex items-center gap-2'>
                                {/* <div>{headerConfig?.section1?.documentIcon || ""}</div> */}
                                <div>
                                    {/* <span><FileText size={20} strokeWidth={2} /></span> */}
                                    <Icons.DocumentViewer className='shrink-0' />
                                </div>

                                {/* render the value of headers */}
                                <p className='mb-0 font-semibold text-base'>{columnConfig?.[headerConfig?.section1?.headerKey]?.() || documentData?.["headerLevel"]?.[headerConfig?.section1?.headerKey] || " - "}</p>
                                <CopyContentGenericComponent
                                    type={2}
                                    content={columnConfig?.[headerConfig?.section1?.headerKey]?.() || documentData?.["headerLevel"]?.[headerConfig?.section1?.headerKey] || " - "}
                                />

                                {/* Render the status keys here */}
                                <div className='flex items-center gap-2'>

                                    {headerConfig?.section1?.statusKeys?.map(key => (
                                        renderStatusKeys(key)
                                    ))}
                                    {/* Render the all details section here */}
                                    {headerConfig?.section1?.allDetails && <GenericCustomButton
                                        label="All Details"
                                        className={'group text-[13px] font-medium flex items-center gap-0.5 hover:opacity-75'}
                                        rightIcon={<div className='duration-200 group-hover:translate-x-1'><ChevronRight size={18} /></div>}
                                        onClick={(e) => handleChange("viewDetailsModal", {
                                            type: "mainLevel",
                                            headerKey: headerConfig?.section1?.headerKey,
                                            documentIcon: headerConfig?.section1?.documentIcon,
                                            data: documentData?.headerLevel,
                                            modalLabel: documentViewerConfig?.getLabel(0, documentData?.headerLevel),
                                            e: e,
                                            ...getHeadersData(0),
                                        })}
                                    />
                                    }
                                </div>
                                {/* Time Information Section Start */}
                                {typeof (headerConfig?.section1?.timeKey) == "function" ? headerConfig?.section1?.timeKey?.({}) : headerConfig?.section1?.timeKey &&
                                    <p className='text-[10px] font-normal text-[#4A5D7A] m-0'>
                                        {/* {headerKeys?.[headerConfig?.section1?.timeKey] || "-"}{" : "} */}
                                        {typeof (columnConfig?.[headerConfig?.section1?.timeKey]) == "function" ?
                                            columnConfig?.[headerConfig?.section1?.timeKey]?.({
                                                data: documentData?.headerLevel || {},
                                            }) :
                                            documentData?.headerLevel?.[headerKeys?.[headerConfig?.section1?.timeKey]] || "-"
                                        } {formatTime(
                                            typeof (columnConfig?.[headerConfig?.section1?.timeKey]) == "function" ?
                                                columnConfig?.[headerConfig?.section1?.timeKey]?.({
                                                    data: documentData?.headerLevel || {},
                                                }) :
                                                documentData?.headerLevel?.[headerKeys?.[headerConfig?.section1?.timeKey]] || "-"
                                        )}
                                    </p>
                                }
                                {/* Time Information Section Ends */}
                            </div>
                            {/* Document Main Level Information Ends */}

                        </div>
                        <div className='relative flex items-center gap-3'>
                            {/* Render the document download dropdown here */}
                            {renderBraedCrumps?.({
                                ...headerConfig?.section3,
                                itemsList: getItemsList?.()
                            })}

                            {documentInfo?.isBackAvaliable &&
                                <GenericCustomButton
                                    type="default"
                                leftIcon={<ChevronLeft size={15}/>} 
                                    label={"Back"}
                                    className={'flex items-center gap-1'}
                                    onClick={() => handleChange("goBack")}
                                />
                            }

                            <div className="gvpd-download-drop">
                                <GenericCustomButton
                                    className={
                                        Object.keys(documentData?.headerLevel).length
                                            ? `gen-action-btn ${documentsDropdown
                                                ? "gen-action-btn-focus"
                                                : "gen-action-btn"
                                            }`
                                            : "opacity04 gen-action-btn"
                                    }
                                    loading={generalStore?.getDocumentDropdownData?.isLoading}
                                    onClick={handleDocumentsDropdown}
                                    disabled={
                                        !Object.keys(documentData?.headerLevel).length ||
                                        actionBarConfig?.downloadDocuments?.disabled
                                    }
                                    leftIcon={
                                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.70825 11.0703C3.13487 11.0703 3.48071 11.4162 3.48071 11.8428V14.9326C3.48071 15.1375 3.5621 15.334 3.70696 15.4788C3.85183 15.6237 4.0483 15.7051 4.25317 15.7051H15.0676C15.2725 15.7051 15.469 15.6237 15.6138 15.4788C15.7587 15.334 15.8401 15.1375 15.8401 14.9326V11.8428C15.8401 11.4162 16.1859 11.0703 16.6125 11.0703C17.0392 11.0703 17.385 11.4162 17.385 11.8428V14.9326C17.385 15.5472 17.1409 16.1367 16.7063 16.5713C16.2717 17.0058 15.6822 17.25 15.0676 17.25H4.25317C3.63857 17.25 3.04913 17.0058 2.61454 16.5713C2.17994 16.1367 1.93579 15.5472 1.93579 14.9326V11.8428C1.93579 11.4162 2.28163 11.0703 2.70825 11.0703Z" fill={(Object.keys(documentData?.headerLevel).length && !(actionBarConfig?.downloadDocuments?.disabledWithValues && Object.values(documentData?.headerLevel).some(item => item[actionBarConfig?.downloadDocuments?.keyForDisable] !== actionBarConfig?.downloadDocuments?.valueForDisable))) ? "#23235F" : "#d8d3d3"} />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M5.25188 7.43719C5.55355 7.13552 6.04264 7.13552 6.34431 7.43719L9.6604 10.7533L12.9765 7.43719C13.2782 7.13552 13.7673 7.13552 14.0689 7.43719C14.3706 7.73885 14.3706 8.22795 14.0689 8.52961L10.2066 12.3919C9.90495 12.6936 9.41585 12.6936 9.11419 12.3919L5.25188 8.52961C4.95022 8.22795 4.95022 7.73885 5.25188 7.43719Z" fill={(Object.keys(documentData?.headerLevel).length && !(actionBarConfig?.downloadDocuments?.disabledWithValues && Object.values(documentData?.headerLevel).some(item => item[actionBarConfig?.downloadDocuments?.keyForDisable] !== actionBarConfig?.downloadDocuments?.valueForDisable))) ? "#23235F" : "#d8d3d3"} />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M9.6604 1.80469C10.087 1.80469 10.4329 2.15053 10.4329 2.57715V11.8467C10.4329 12.2733 10.087 12.6191 9.6604 12.6191C9.23378 12.6191 8.88794 12.2733 8.88794 11.8467V2.57715C8.88794 2.15053 9.23378 1.80469 9.6604 1.80469Z" fill={(Object.keys(documentData?.headerLevel).length && !(actionBarConfig?.downloadDocuments?.disabledWithValues && Object.values(documentData?.headerLevel).some(item => item[actionBarConfig?.downloadDocuments?.keyForDisable] !== actionBarConfig?.downloadDocuments?.valueForDisable))) ? "#23235F" : "#d8d3d3"} />
                                        </svg>
                                    }
                                    label={Object.keys(documentData?.headerLevel || {}).length > 0 && (
                                        <LanguageTranslator tag="span" className="generic-tooltip zi999">
                                            Download Documents
                                        </LanguageTranslator>
                                    )
                                    }
                                />
                                {documentsDropdown && (
                                    <div className="backdrop-transparent zIndex9 z-[9]" onClick={() => handleDocumentsDropdown()}></div>
                                )}
                                {documentsDropdown && (
                                    <DocumentsDropdown
                                        OpenDocumentsDropdown={handleDocumentsDropdown}
                                        downloadDocumentsConfigurationObject={downloadDocumentsConfigurationObject || {}}
                                        checkItems={[documentData?.headerLevel]}
                                        downloadDocuments={actionBarConfig?.downloadDocuments || {}}
                                        {...props}
                                    />
                                )}
                            </div>

                            {/* {actionBarConfig?.downloadReport &&
                                <GenericCustomButton
                                    className="gen-action-btn tableExportExcel"
                                    onClick={() => setDownloadReportModal(!downloadReportModal)}
                                    loading={false}
                                    disabled={generalStore?.getHeadersData?.isLoading || generalStore.downloadReport?.isLoading}
                                    leftIcon={<Icons.ExportToExcel />}
                                    label={
                                        <LanguageTranslator tag="span" className="generic-tooltip zi999">Export to Excel</LanguageTranslator>
                                    }
                                />} */}

                            <div className='flex items-center gap-2 cursor-pointer hover:opacity-75' onClick={props?.closeModal}>
                                <p className='mb-0 text-[11px]'>Esc</p>
                                <div className='h-[12px] w-[1px] bg-black'></div>
                                <div><X size={17} /></div>
                            </div>

                            {/* Render the actions list here */}
                            {/* <div className='relative'>
                                <GenericCustomButton
                                    label={'Actions'}
                                    iconRight={<Power />}
                                    type="primary"
                                    onClick={handleToggleDropdown}
                                />
                                <div ref={dropdownRef} className={`documentViewerDropdown mt-[4px] absolute from-top-in top-full !left-auto !right-0 z-[4] min-w-[170px] bg-white drop-shadow-lg duration-200 ${openDropdown ? 'visible pointer-events-auto opacity-100 translate-y-0' : 'invisible pointer-events-none opacity-0 -translate-y-2'}`}>
                                    {renderRightClickOptions({
                                        hideTableAction: true,
                                        itemsList: getItemsList?.()
                                    })}
                                </div>
                            </div> */}

                        </div>
                    </div>
                    <div className='mb-4 px-4 flex items-center justify-between gap-5'>
                        <div className='flex items-center gap-7'>
                            {/* Render the section 2 data here */}
                            {
                                headerConfig?.["section2"]?.["detailsKeys"]?.map(key => (
                                    <div>
                                        <div className='mb-1 flex items-center gap-1.5'>
                                            {headerKeyIcons?.[key] && <div className='shrink-0'>
                                                {headerKeyIcons?.[key] && typeof (headerKeyIcons?.[key]) === "function" ? headerKeyIcons?.[key]() : <div className='h-[12px] w-[12px] shrink-0 flex items-center justify-center'>{headerKeyIcons?.[key]}</div>}
                                            </div>}
                                            <LanguageTranslator tag='p' className='mb-0 text-[11px] text-[#4A5D7A] flex items-center'>{headerKeys?.[key] || " - "}</LanguageTranslator>
                                            {headerKeys?.[key] === 'PO Number' && <CopyContentGenericComponent
                                                type={2}
                                                content={columnConfig?.[key] ?
                                                    columnConfig?.[key]?.({ data: documentData?.headerLevel })
                                                    : documentData?.headerLevel?.[key] || " - "
                                                }
                                            />}

                                        </div>
                                        <p className='mb-0 text-[11px] flex items-center'>{columnConfig?.[key] ?
                                            columnConfig?.[key]?.({ data: documentData?.headerLevel })
                                            : documentData?.headerLevel?.[key] || " - "
                                        }</p>
                                    </div>

                                ))
                            }
                        </div>
                    </div>
                    {Object.keys(headerConfig?.["section4"] || {})?.length > 0 &&
                        <div className='px-4 flex items-center justify-between'>
                            {/* Render the quantity key here */}
                            {headerConfig?.["section4"]?.["totalQty"] && <div className='flex items-center gap-2'>
                                <div className='bg-[#fafafa] rounded-[10px] px-3 py-2 flex items-center gap-4 justify-between min-w-[140px] min-h-[69px]'>
                                    <div className=''>
                                        <p className='mb-0 text-base font-semibold'>{documentData?.["headerLevel"]?.[headerConfig?.["section4"]?.["totalQty"]] || " - "}</p>
                                        <LanguageTranslator tag='p' className='text-[11px] text-[#4A5D7A] mb-0'>{headerKeys?.[headerConfig?.["section4"]?.["totalQty"]] || "-"}</LanguageTranslator>
                                    </div>
                                    <div className='shrink-0 mt-[24px]'>
                                        {getFileIcon?.[headerConfig?.["section4"]?.["totalQty"]] || '-'}
                                    </div>
                                </div>
                                <span className='text-[#4A5D7A] text-[13px]'>=</span>
                                {headerConfig?.["section4"]?.["remainingQtyKey"]?.length > 0 && headerConfig?.["section4"]?.["remainingQtyKey"]?.map((key, index) => {
                                    // if (documentData?.["headerLevel"]?.[key] && Number(documentData?.["headerLevel"]?.[key] || 0) > 0) {
                                    return (
                                        <>
                                            <div className='bg-[#fafafa] rounded-[10px] px-3 py-2 flex items-center gap-4 justify-between min-w-[140px] min-h-[69px]'>
                                                <div className=''>
                                                    <p className='mb-0 text-base font-semibold'>{documentData?.["headerLevel"]?.[key] ?? " - "}</p>
                                                    <LanguageTranslator tag='p' className='text-[11px] text-[#4A5D7A] mb-0'>{headerKeys?.[key] || "-"}</LanguageTranslator>
                                                </div>
                                                <div className='shrink-0 mt-[24px]'>{getFileIcon?.[key] || '-'}</div>
                                            </div>
                                            <div className='mt-[14px] text-[#4A5D7A] text-[13px]'>{(headerConfig?.["section4"]?.["remainingQtyKey"]?.length - 1) !== index && "+"}</div>
                                        </>
                                    )
                                    // }
                                })}
                            </div>}

                            {headerConfig?.["section4"]?.["amountKey"] && <div className='flex items-center gap-2.5'>

                                {Object.keys(headerConfig?.section5 || {})?.map((key, index) => {
                                    // if (documentData?.["headerLevel"]?.[headerConfig?.section5?.[key]] && Number(documentData?.["headerLevel"]?.[headerConfig?.section5?.[key]] || 0) > 0) {
                                    return (
                                        <div className='bg-[#fafafa] rounded-[10px] px-3 py-2 min-w-[128px] min-h-[69px] flex flex-col justify-center'>
                                            <LanguageTranslator tag='p' className='text-[11px] text-[#4A5D7A] mb-0'>{headerConfig?.section5?.[key] || "-"}</LanguageTranslator>
                                            <div className='flex items-baseline gap-3'>
                                                <p className='mb-0 text-2xl font-semibold'>{documentData?.["headerLevel"]?.[key] ?? 0}%</p>

                                                {/* progress bar */}
                                                <div className="w-[50px] h-[6px] rounded bg-gray-200 overflow-hidden">
                                                    <div className="h-full bg-blue-500" style={{ width: Number(documentData?.["headerLevel"]?.[key] || 0) }}></div>
                                                </div>
                                            </div>
                                            {/* <progress value={Number(documentData?.["headerLevel"]?.[headerConfig?.section5?.[key]] || 0)} max="100"></progress> */}
                                        </div>
                                    )
                                    // }
                                })}

                                <div className='bg-[#fafafa] rounded-[10px] px-3 py-2 min-w-[140px] min-h-[69px] flex flex-col justify-center'>
                                    <div>
                                        <p className='mb-0 text-base font-semibold flex items-center gap-0.5'>{CURRENCIES?.[documentData?.["headerLevel"]?.currency] ?? <IndianRupeeIcon size={16} />} {documentData?.["headerLevel"]?.[headerConfig?.["section4"]?.["amountKey"]] || " - "}</p>
                                    </div>
                                    <div className='flex items-center gap-4'>
                                        <LanguageTranslator tag='p' className='text-[11px] text-[#4A5D7A] mb-0'>{headerKeys?.[headerConfig?.["section4"]?.["amountKey"]] || "-"}</LanguageTranslator>
                                        <div className='shrink-0'>{getFileIcon?.[headerConfig?.["section4"]?.["amountKey"]] || '-'}</div>
                                    </div>
                                </div>
                            </div>}
                        </div>}
                </div>
            </div>

            {/* Render the search section and the grid and list selection here */}
            <div className='flex items-center justify-between gap-3 px-3.5 py-3'>
                {/* Render the tabs section here */}
                <GenericTabsComponent
                    className={'!border-y-0'}
                    // tabsData={{
                    //     "itemDetails": "Item Details",
                    //     "liveComments": <div className='flex items-center gap-1.5'><Icons.CommentIcon /> Live Comments {getUnreadCommentForThisDocument()}</div>,
                    //     "history": "Document Flow"
                    // }}
                    tabsData={tabsData}
                    tabsKey={"currentTab"}
                    handleTabChange={(val) => {
                        setCurrentTab(val);
                        setCurrentSearch("");
                    }}
                    current={currentTab}
                    type={1}
                />
                <div className='new-gen-pagination flex items-center'>
                    {/* Render the search input */}
                    <div className='w-1/5 min-w-[150px]'>
                        <GenericInput
                            genInputExtraClass='!mb-0'
                            inputKey={"currentSearch"}
                            placeholder={search?.placeholder ?? "Type To Search"}
                            iconLeft={search?.iconLeft ?? <Icons.SearchIconBlack className='shrink-0 mr-[4px]' />}
                            onChange={(e) => {
                                setCurrentSearch(e?.target?.value)
                                if (e?.target.value == "") {
                                    applySearchAndFilterOnDocumentSecondLevel("");
                                }
                            }}
                            value={currentSearch}
                            dependentFieldsObject={["currentSearch"]}
                            onKeyDown={(e) => {
                                if (e.key == "Enter") {
                                    applySearchAndFilterOnDocumentSecondLevel();
                                }
                            }}
                        />
                    </div>

                    {/* Render the option to switch between the grid and list type */}
                    {/* {removeGridListToggle ? null : 
                    <GridListToggle
                        viewTypeList={{
                            "grid": true,
                            "list": true,
                        }}
                        onChange={(key) => setMode(key)}
                        current={mode}
                    />} */}
                    {(currentTab === "ITEM" || currentTab === "BOX") && <>
                        <div className="drop-toggle-btn tablePageSize">
                            <button type="button" className="dtb-show">
                                <span className="total-count">
                                    <span className='to-num'>{secondExpandData?.totalRecord <= secondExpandData?.pageSize ? secondExpandData?.totalRecord : secondExpandData?.pageSize || "10"}</span>
                                    <LanguageTranslator tag="span" className="to-slas">of</LanguageTranslator>
                                    <span className='to-num'>{secondExpandData?.totalRecord}
                                        <span className="generic-tooltip">
                                            {secondExpandData?.totalRecord}
                                        </span>
                                    </span>
                                </span>
                                <LanguageTranslator>{`Item${secondExpandData?.totalRecord > 1 ? "s" : ""}`}</LanguageTranslator>
                            </button>
                        </div>
                        <div className="ngp-right tablePagination ml-2.5">
                            <div className="nt-btn">
                                <div className="pagination-inner">
                                    <ul className="pagination-item flex">
                                        <li>
                                            <button className={`${secondExpandData?.currentPage == 1 && "gen-action-btn-disable disable-"}first-btn`} disabled={secondExpandData?.currentPage == 1} onClick={() => changePage(1)}>
                                                <span className="page-item-btn-inner">
                                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M10.8977 6.49114C11.2557 6.84912 11.2557 7.42952 10.8977 7.7875L6.96254 11.7227L10.8977 15.6578C11.2557 16.0158 11.2557 16.5962 10.8977 16.9542C10.5397 17.3122 9.95931 17.3122 9.60133 16.9542L5.018 12.3708C4.66002 12.0129 4.66002 11.4325 5.018 11.0745L9.60133 6.49114C9.95931 6.13316 10.5397 6.13316 10.8977 6.49114Z" fill="#23235F" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M17.3143 6.49114C17.6723 6.84912 17.6723 7.42952 17.3143 7.7875L13.3792 11.7227L17.3143 15.6578C17.6723 16.0158 17.6723 16.5962 17.3143 16.9542C16.9563 17.3122 16.3759 17.3122 16.018 16.9542L11.4346 12.3708C11.0766 12.0129 11.0766 11.4325 11.4346 11.0745L16.018 6.49114C16.3759 6.13316 16.9563 6.13316 17.3143 6.49114Z" fill="#23235F" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </li>
                                        <li>
                                            <button className={`${secondExpandData?.currentPage == 1 && "gen-action-btn-disable dis-"}prev-btn`} disabled={secondExpandData?.currentPage == 1} onClick={() => changePage(secondExpandData?.currentPage - 1)}>
                                                <span className="page-item-btn-inner">
                                                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.89781 0.491142C7.2558 0.849122 7.2558 1.42952 6.89781 1.7875L2.96266 5.72266L6.89781 9.65781C7.2558 10.0158 7.2558 10.5962 6.89781 10.9542C6.53983 11.3122 5.95943 11.3122 5.60145 10.9542L1.01812 6.37084C0.660139 6.01286 0.660139 5.43246 1.01812 5.07448L5.60145 0.491142C5.95943 0.133161 6.53983 0.133161 6.89781 0.491142Z" fill="#23235F" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </li>
                                        <li>
                                            {!enableJumpPage ? <button className="pi-number-btn" onClick={() => handleJumpPage()}>
                                                <span className='flex'>{secondExpandData?.currentPage}<label>of</label>{secondExpandData?.maxPage}</span>
                                            </button> : <input
                                                ref={jumpInputRef}
                                                className="pinum-input"
                                                onChange={setPageNumberValue}
                                                onKeyDown={setPageNumberValue}
                                                type="number"
                                                autoComplete="off"
                                                value={secondExpandData?.pageNumber}
                                            />}
                                        </li>
                                        <li>
                                            <button className={`${secondExpandData?.currentPage == secondExpandData?.maxPage && "gen-action-btn-disable dis-"}next-btn`} disabled={secondExpandData?.currentPage == secondExpandData?.maxPage} onClick={() => changePage(secondExpandData?.currentPage + 1)}>
                                                <span className="page-item-btn-inner">
                                                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.934461 0.491142C0.57648 0.849122 0.57648 1.42952 0.934461 1.7875L4.86961 5.72266L0.934461 9.65781C0.57648 10.0158 0.57648 10.5962 0.934461 10.9542C1.29244 11.3122 1.87284 11.3122 2.23082 10.9542L6.81416 6.37084C7.17214 6.01286 7.17214 5.43246 6.81416 5.07448L2.23082 0.491142C1.87284 0.133161 1.29244 0.133161 0.934461 0.491142Z" fill="#23235F" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </li>
                                        <li >
                                            <button className={`${secondExpandData?.currentPage == secondExpandData?.maxPage && "gen-action-btn-disable dis-"}last-btn`} disabled={secondExpandData?.currentPage == secondExpandData?.maxPage} onClick={() => changePage(secondExpandData?.maxPage)}>
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9346 6.49114C11.5766 6.84912 11.5766 7.42952 11.9346 7.7875L15.8697 11.7227L11.9346 15.6578C11.5766 16.0158 11.5766 16.5962 11.9346 16.9542C12.2926 17.3122 12.873 17.3122 13.2309 16.9542L17.8143 12.3708C18.1723 12.0129 18.1723 11.4325 17.8143 11.0745L13.2309 6.49114C12.873 6.13316 12.2926 6.13316 11.9346 6.49114Z" fill="#23235F" />
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.51796 6.49114C5.15998 6.84912 5.15998 7.42952 5.51796 7.7875L9.45311 11.7227L5.51796 15.6578C5.15998 16.0158 5.15998 16.5962 5.51796 16.9542C5.87594 17.3122 6.45634 17.3122 6.81432 16.9542L11.3977 12.3708C11.7556 12.0129 11.7556 11.4325 11.3977 11.0745L6.81432 6.49114C6.45634 6.13316 5.87594 6.13316 5.51796 6.49114Z" fill="#23235F" />
                                                </svg>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </>}
                </div>
            </div>

            {renderDocumentDetails()}

        </div>
    }

    const getParentChildProps = () => {
        switch (selectedModal) {
            case "allDetailsModal": {
                return {
                    closeModal: () => { setSelectedModal(null) },
                    animationType: "AlignBottom",
                    parentModalOuterMostClassName: 'flex items-end justify-center mb-[5%]',
                    postitionProps: { position: 'relative' },
                    // dimensions: {width: "100%", height: 'fit-content', maxHeight: "400px", borderRadius:'0'},
                    dimensions: { width: "100%", height: '45%', maxHeight: "350px", borderRadius: '0' },
                    detailsModal: detailsModal,
                    tableConfig: tableConfig,
                }
            }
            case "viewImagePreview": {
                let extName = getFileTypeFromUrl(detailsModal || "");
                let type = getFileNameFromExt(extName);
                return {
                    animationType: "bottom",
                    closeModal: () => { setSelectedModal(null); setDetailsModal({}) },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "100vw", height: "100vh", backgroundColor: 'transparent' },
                    filesData: [{
                        fileUrl: detailsModal,
                        fileType: type,
                    }],
                }
            }
            case "designStage": return {
                closeModal: () => { setSelectedModal(false); setDetailsModal(null) },
                parentModalOuterMostClassName: 'flex items-center justify-center',
                postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", margin: 0 },
                dimensions: { width: "500px", height: "100vh", maxWidth: '100vw', borderRadius: 5 },
                animationType: "right",
                detailsModal: detailsModal,
                documentInfo
            }
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "allDetailsModal": return DocumentViewerDetailsModal;
            case "viewImagePreview": return GenericMediaViewModal;
            case "designStage": return DesignStagesModal;
        }
    }

    const generatePayload = (data) => {
        let payload = { ...data };
        if(documentInfo?.documentType == "PO") {
            payload.data = {
                ...payload.data,
                orderNumber: documentInfo?.documentNo || ""
            }
        }
        else {
            payload.data = {
                ...payload.data,
                documentNo: documentInfo?.documentNo || ""
            }
        }
        return payload
    }

    return (
        <>
            <div className={`document-viewer-container w-full h-full overflow-hidden outline-none !flex items-center justify-center ${embedded ? 'relative' : 'fixed top-1/2 right-0 bottom-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[999]'}`}>
                {!embedded && <div className='backdrop modal-backdrop-new' onClick={closeDocumentViewer}></div>}
                <div id="documentViewerModal" className={`modal-content bg-white text-fontBlack ${embedded ? '!w-full !h-full !relative' : 'from-bot-in !w-[95%] !h-[95%]'}`} style={embedded ? undefined : { top: 0 }}>
                    {renderDocument()}
                </div>
            </div>
            {downloadReportModal &&
                <DownloadReport
                    dataLength={1}
                    mainHeadersKey={docViewerHeaderKeys?.["MAIN"]?.key}
                    headerLevelModule={docViewerHeaderKeys?.["MAIN"]?.key}
                    mainHeadersData={getDocumentViewHeadersData?.headersData}
                    mainHeadersType={getDocumentViewHeadersData?.headersType}
                    payload={{}}
                    submit={(payload) => { handleApiChange(dispatch, "downloadReportRequest", generatePayload(payload), getPermissionKey("common", "commonFunctionality", "view")) }}
                    loading={generalStore.downloadReportData.isLoading}
                    close={() => setDownloadReportModal(false)}
                    getFilterValue={() => { }}
                    getItemFilterValue={() => { }}
                    downloadReportName={false}
                    applyFilter={() => { }}
                    detailLevelModule={Object.values(docViewerHeaderKeys || {})?.map(item => item?.key)?.join()}
                    detailHeadersData={Object.keys(detailsHeaders || {})?.map((key) => {
                        if (detailsHeaders?.[key]?.headersData) {
                            return detailsHeaders?.[key]?.headersData
                        }
                    })}
                    detailHeadersType={Object.keys(detailsHeaders || {})?.map((key) => {
                        if (detailsHeaders?.[key]?.headersType) {
                            return detailsHeaders?.[key]?.headersType
                        }
                    })}
                    {...actionBarConfig.downloadReport}
                    generalStore={generalStore}
                    {...props}
                />}
            {selectedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false) }}
            />}
        </>
    )
}

export default DocumentViewer